import React from 'react';
import { WbMarkdownHtml } from '../../../../utils/common';
import { AiRecentActivityProps } from '../../../types/sidePanel.types';

const AiRecentActivityComp = ({ aiRecentAct }: AiRecentActivityProps) => (
  <div>
    {aiRecentAct != null && Object.keys(aiRecentAct).length
      ? Object.keys(aiRecentAct).map((item, index) => (
        // used index because items are just rendered, any actions (CRUD) are not possible
        // eslint-disable-next-line react/no-array-index-key
        <div className="wsBoardAiRecentActWrapper displayTable tabLayFix width100" key={index}>
          <div className="displayRow">
            <div
              className="displayCell wsBoardRecActText"
              dangerouslySetInnerHTML={WbMarkdownHtml(
                aiRecentAct[item].text
              )}
            />
            <div
              className="displayCell wsBoardRecActDate"
              dangerouslySetInnerHTML={WbMarkdownHtml(
                aiRecentAct[item].date
              )}
            />
          </div>
        </div>
      ))
      : ''}
  </div>
);

export default AiRecentActivityComp;
